import actions from "~/actions";
import { AddAgentIcon, UsersInviteIcon } from "~/icons";
import { Subscription, UserRole } from "~/shared/enums";
import type { NoOptionAction } from "~/shared/types";
import { useAppStore, useDataStore, useTenantStore } from "~/stores";
import { validateEmail } from "~/utils/validation";

export const createAgentNoOptionAction: NoOptionAction = {
  icon: AddAgentIcon,
  makeText: (search) => `Create agent "${search.trim()}"`,
  validate: (search) =>
    search.trim().length > 0 ? { isValid: true } : { isValid: false, error: "Enter an agent name" },
  roleOverride: UserRole.MEMBER,
  closeOnAction: true,
  onAction: async (name) => {
    const appStore = useAppStore();
    const dataStore = useDataStore();
    const agent = await dataStore.createAgent(name.trim());
    appStore.pendingAgentImageGenerationDuid = agent.duid;
    dataStore.$router.push({ name: "agent", params: { agentDuid: agent.duid } });
  },
};

export const makeInviteByEmailNoOptionAction = (onInvited: (duid: string) => void): NoOptionAction => ({
  icon: UsersInviteIcon,
  makeText: (search) => `Invite ${search.trim()} by email`,
  validate: (email) => validateEmail(email.trim()),
  roleOverride: UserRole.MEMBER,
  onAction: async (email) => {
    const tenantStore = useTenantStore();
    const dataStore = useDataStore();
    const normalizedEmail = email.trim().toLowerCase();
    const { invitedEmails } = await actions.auth.inviteUsers(
      tenantStore.isSubscriptionGte(Subscription.APP_SUMO) ? UserRole.MEMBER : UserRole.ADMIN,
      [normalizedEmail]
    );
    if (!invitedEmails.includes(normalizedEmail)) {
      return;
    }
    const user = dataStore.getUserByEmail(normalizedEmail);
    if (user) {
      onInvited(user.duid);
    }
  },
});
